import PoppingBadge from './PoppingBadge'

export default PoppingBadge
